/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import { Button, Switch } from 'react-toolbox/lib/';
import { list2 } from '~/actions/tasks';
import Task from '~/components/Task';
import Spinner from '~/components/Spinner';
import MultiPicker from '~/components/MultiPicker';
import LocationPicker from '~/components/LocationPicker';
import OrderPicker from '~/components/OrderPicker';
import ArticlePicker from '~/components/ArticlePicker';
import ContainerPicker from '~/components/ContainerPicker';
import UserPicker from '~/components/UserPicker';
import TaskPicker from '~/components/TaskPicker';
import style from './style.scss';

const components = {
  orderId: {
    label: 'Order',
    component: OrderPicker,
    required: false
  },
  locationId: {
    label: 'Location',
    component: LocationPicker,
    required: false
  },
  parentTaskId: {
    label: 'Parent Task',
    component: MultiPicker(TaskPicker),
    required: false
  },
  userId: {
    label: 'User',
    component: UserPicker,
    required: false
  },
  articleIds: {
    label: 'Article',
    component: MultiPicker(ArticlePicker),
    required: false
  },
  containerId: {
    label: 'Container',
    component: ContainerPicker,
    required: false
  },
};

class Tasks extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      results: [],
      query: '',
      resolved: false,
      ids: {
        orderId: '',
        locationId: '',
        parentTaskId: [],
        userId: '',
        articleIds: [],
        containerId: ''
      }
    };
  }

  componentDidMount() {
    this.search();
  }

  getStatus(id) {
    const task = this.props.tasks[id];
    const parents = this.state.results
      .find(taskId => task.parentTaskId.includes(taskId) && task.resolution === undefined);
    if (task.resolution) {
      return task.resolution.type;
    }
    if (parents) {
      return 'blocked';
    }
    return 'pending';
  }

  search() {
    this.setState({ loading: true });
    list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.ids,
    )
      .then(r => {
        this.setState({
          results: r.data.results.map(i => i.id),
          skipId: r.data.skipId,
          more: r.data.more,
          loading: false,
        });
      })
      .catch(() => this.setState({ loading: false }));
  }

  loadMore() {
    this.setState({ loading: true });
    list2(
      this.props.dispatch,
      this.context.apiClient,
      this.state.query,
      this.state.ids,
      this.state.skipId,
    )
      .then(r => this.setState({
        results: [...this.state.results, ...r.data.results.map(i => i.id)],
        skipId: r.data.skipId,
        more: r.data.more,
        loading: false,
      }))
      .catch(() => this.setState({ loading: false }));
  }

  render() {
    const pending = this.state.results.filter(id => this.getStatus(id) === 'pending');
    const notPending = this.state.results.filter(id => this.getStatus(id) !== 'pending');
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title} style={{ marginTop: '10px' }}>Tasks</div>
        <Button className={style.buttonNew} primary raised label="New task" icon="add" onClick={() => this.context.dialogPush('taskNew')} />
        <form onSubmit={e => { e.preventDefault(); this.setState({ skipId: null }); this.search(); }} style={{ marginBottom: '10px' }}>
          <input
            placeholder="Search Type, SKU, and ID"
            className={style.searchField}
            value={this.state.query}
            onChange={e => this.setState({ query: e.target.value })}
          />
          <div className={style.filters}>
            <b>Filters</b>
            {Object.keys(components).map(key => {
              const Cmp = components[key].component;
              const field = components[key];
              return (
                <div className={style.filter}>
                  <div className={style.label}>{components[key].label}</div>
                  <div className={style.item}>
                    {Cmp ? <Cmp
                      key={field.label}
                      id={field.label}
                      value={this.state.ids[key]}
                      required={field.required}
                      onChange={id => this.setState({ ids: { ...this.state.ids, [key]: id } })}
                    /> : `Unknown field type "${field.type}"`
                    }
                  </div>
                </div>
              );
            })}
            <Switch
              checked={this.state.resolved}
              label="Resolved"
              onChange={() => this.setState({ resolved: !this.state.resolved })}
            />
          </div>
          <Button label="Find" primary raised type="submit" />
        </form>
        {this.state.loading && <div><Spinner /></div>}
        {!this.state.loading && !this.state.resolved && <div>
          {pending.map(id => <Task className={style.task} key={id} id={id} />)}
          {pending.length === 0 && <div style={{ padding: '10px' }}>No tasks found</div>}
        </div>}
        {this.state.loading && <div><Spinner /></div>}
        {!this.state.loading && this.state.resolved && <div>
          {notPending.map(id => <Task className={style.task} key={id} id={id} />)}
          {notPending.length === 0 && <div style={{ padding: '10px' }}>No tasks found</div>}
        </div>}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tasks: state.getIn(['tasks', 'items']).toJS(),
});

export default connect(mapStateToProps)(Tasks);



// WEBPACK FOOTER //
// ./app/pages/Tasks/index.js